import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../../store';
import seluxLogo from '../../../../icons/selux-logo';
import {cssProperties} from '../../../css/cssProperties';

@customElement('solar-specsheet-footer')
export class SolarSpecsheetFooter extends connect(store)(LitElement) {

	static styles = [
	css`
		:host {
			position: absolute;
			bottom: 0;
			right: 0;
			left: 0;
		}

		.footer {
			display: flex;
			justify-content: space-between;
			margin: 0 var(--specsheet-large-gap);
			align-items: center;
		}

		.footer-text {
			width: 60%;
		}

		.logo {
			width: 78px;
			display: inline-block;
			vertical-align: bottom;
		}

		.address {
			font: var(--font-specsheet-print-small-light);
		}

		.address span {
			font: var(--font-specsheet-print-small-bold);
		}

		.date {
			font: var(--font-specsheet-print-small-light);

		}
		.price {
			font: var(--font-specsheet-print-small-light);
		}

		@media print {
			:host {
				position: absolute;
				bottom: 0px;
				right: 0;
				left: 0;
				margin: 0;
			}

			.footer {
				display: flex;
				justify-content: space-between;
				margin: 0;
				align-items: center;
				box-sizing: border-box;
				margin: 0;
				width: 100%;
			}

			.footer-text {
				flex: 3;
				width: 60%;
			}

			.logo {
				width: 78px;
				display: inline-block;
				vertical-align: bottom;
				flex: 1;
			}

		}
	}
	`
	]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		const s = this.state;
		return html`
		<div class="footer">
			<div class="flex-item footer-text">
				<p>
					Unverschattet, Ausrichtung Leuchtenkopf nach Norden.
					Referenztage: Winter 21.12., Sommer XXm Frühjahr/Herbst: XX.
					<a href="https://www.selux.com/" target="_blank">Weitere Information und Zugang Epertenmodus.</a>
				</p>
				<p class="address">
					<trans-label key="TE_Footer" context="D.L"></trans-label>
				<br><span>Selux GmbH, Volkmarstraße 18, D-12099 Berlin, T +49 30 72001-0, F -100, info@selux.com, www.selux.com</span></p>
			</div>

			<div class="flex-item logo">
					<div class="logo">
						${seluxLogo}
					</div>
				</div>
		</div>
		`;
	}
}
